import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";
import { List, Check, Info } from "lucide-react";

const ArticlePage = () => {
  const breadcrumbs = [
    { label: "Elite", href: "/" },
    { label: "Blog", href: "/blog" },
    { label: "Como Funciona um Painel IPTV Pós Pago", href: "/blog/como-funciona-painel-iptv-pos-pago" }
  ];

  const sections = [
    {
      title: "O Passo a Passo da Operação Pós-Paga",
      content: (
        <div className="prose prose-invert max-w-none">
          <p className="text-lg text-muted-foreground mb-6">
            Muitos revendedores têm dúvidas sobre como funciona a logística de um painel sem a necessidade de créditos antecipados. A lógica é simples: o risco financeiro sai das suas costas e fica na nossa estrutura.
          </p>
          <ul className="space-y-4">
            <li className="flex gap-4">
              <div className="w-8 h-8 rounded-full bg-electric/20 text-electric flex items-center justify-center flex-shrink-0 font-bold">1</div>
              <p className="text-muted-foreground"><strong>Liberação do Painel:</strong> Você recebe acesso total para criar usuários e testes ilimitados.</p>
            </li>
            <li className="flex gap-4">
              <div className="w-8 h-8 rounded-full bg-electric/20 text-electric flex items-center justify-center flex-shrink-0 font-bold">2</div>
              <p className="text-muted-foreground"><strong>Venda e Ativação:</strong> Ao fechar com um cliente, você o ativa imediatamente no sistema.</p>
            </li>
            <li className="flex gap-4">
              <div className="w-8 h-8 rounded-full bg-electric/20 text-electric flex items-center justify-center flex-shrink-0 font-bold">3</div>
              <p className="text-muted-foreground"><strong>Acerto Mensal:</strong> No dia combinado, geramos um relatório de quantos clientes ativos você manteve e você paga o valor correspondente.</p>
            </li>
          </ul>
        </div>
      )
    }
  ];

  return (
    <SEOPage
      category="Como Funciona um Painel IPTV Pós Pago"
      title="Como Funciona um Painel IPTV Pós Pago: Guia Técnico"
      subtitle="Entenda o funcionamento detalhado por trás do modelo de negócio mais lucrativo para revenda de streaming."
      heroImage="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1200"
      introParagraphs={[
        "O sistema pós-pago é a evolução natural do mercado de IPTV. Ele permite que você foque no que realmente importa: vender e atender bem seus clientes, sem se preocupar se tem créditos na conta.",
        "Neste guia, explicamos como nossa tecnologia monitora as linhas ativas e como funciona o ciclo de faturamento para garantir total transparência ao parceiro."
      ]}
      benefits={[
        { title: "Sem Créditos", description: "Esqueça a necessidade de comprar pacotes de créditos para trabalhar." },
        { title: "Gestão Ágil", description: "Controle total da sua base de clientes através de uma interface intuitiva." }
      ]}
      howItWorks={[
        { title: "Acesso", description: "Receba seus dados de acesso ao painel mestre." },
        { title: "Operação", description: "Ative clientes conforme sua demanda cresce." }
      ]}
      diferenciais={[
        { title: "Transparência", description: "Relatórios detalhados de consumo para total controle financeiro." }
      ]}
      faq={[
        { question: "O painel é bloqueado se eu não vender?", answer: "Não. O painel permanece ativo para que você possa buscar seus primeiros clientes com tranquilidade." }
      ]}
      breadcrumbs={breadcrumbs}
      sections={sections}
      ctaTitle="🚀 Quer Ver na Prática como Funciona?"
      ctaDescription="Solicite uma demonstração do nosso painel pós-pago agora mesmo."
      ctaButtonText="Ver Demonstração"
    />
  );
};

export const Route = createFileRoute("/blog/como-funciona-painel-iptv-pos-pago")({
  head: () => ({
    meta: [
      { title: "Como Funciona um Painel IPTV Pós Pago - Guia Completo | P2 PRO" },
      { name: "description", content: "Aprenda o funcionamento técnico e comercial do painel IPTV pós-pago. Veja como ativar clientes e gerenciar seu faturamento mensal." }
    ],
  }),
  component: ArticlePage,
});
